<template>
  <div class="collect-email-widget">
    <p>📩 Enter your email to stay connected:</p>
    <input
      type="email"
      v-model="email"
      placeholder="you@example.com"
      class="email-input"
      @input="validateEmail"
    />
    <p v-if="email && !isValid" class="error-message">Please enter a valid email address.</p>
    <button @click="submitEmail" :disabled="!isValid">Submit</button>
  </div>
</template>


<script setup>
import { ref } from 'vue';

const emit = defineEmits(['submit']);
const email = ref('');
const isValid = ref(false);

function validateEmail() {
  const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  isValid.value = pattern.test(email.value.trim());
}

function submitEmail() {
  if (isValid.value) {
    emit('submit', email.value.trim());
  }
}

</script>

<style scoped>
.collect-email-widget {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  border: 2px solid #663399;
  background-color: #f3e8ff;
  align-items: center;
  text-align: center;
}
.email-input {
  padding: 10px;
  font-size: 1rem;
  width: 100%;
  max-width: 300px;
  border-radius: 6px;
  border: 1px solid #ccc;
}
.error-message {
  color: #cc0000;
  font-size: 0.85rem;
  margin-top: -8px;
  margin-bottom: 8px;
}
</style>
